import { Heading, HFlow, Text } from 'bold-ui'
import React, { Fragment } from 'react'

interface VacinacaoModalHeaderProps {
  imunobiologicoNome: string
  imunobiologicoSigla: string
  nomeDose: string
  idadeRecomendada: string
  outrosImunobiologicos?: boolean
  labelTipoRegistro?: string
}

export const VacinacaoModalHeader = (props: VacinacaoModalHeaderProps) => {
  const {
    imunobiologicoNome,
    nomeDose,
    idadeRecomendada,
    imunobiologicoSigla,
    outrosImunobiologicos,
    labelTipoRegistro,
  } = props

  return outrosImunobiologicos ? (
    <Heading level={1}>{labelTipoRegistro} de imunobiológico</Heading>
  ) : (
    <Fragment>
      <HFlow alignItems='center' hSpacing={0.5}>
        <Heading level={1}>{imunobiologicoSigla}</Heading>
        <Heading level={3}>{nomeDose}</Heading>
        {idadeRecomendada && <Text fontSize={1}>| {idadeRecomendada?.capitalize()}</Text>}
      </HFlow>
      <Text>{imunobiologicoNome}</Text>
    </Fragment>
  )
}
